// Single source of truth for restaurant contact information.
// Update phone numbers / address here to propagate across the whole site.

export const RESTAURANT = {
  name: "Ristorante Grappolo d'Oro",
  shortName: "Grappolo d'Oro",
  since: 1952,
  // Mobile for reservations & WhatsApp (international format, no spaces)
  mobile: "+393488892478",
  mobileDisplay: "+39 348 889 2478",
  // Existing landline from the hotel+restaurant website
  landline: "+390173782930",
  landlineDisplay: "0173 78293",
  email: "info@grappolodoro.net",
  address: {
    street: "Piazza Umberto I, 5",
    cap: "12065",
    city: "Monforte d'Alba",
    province: "CN",
    country: "Italia",
  },
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Ristorante+Grappolo+d%27Oro+Piazza+Umberto+I+5+Monforte+d%27Alba",
  mapsEmbed:
    "https://www.google.com/maps?q=Piazza+Umberto+I+5+Monforte+d%27Alba&hl=it&z=16&output=embed",
  pIva: "03589860042",
};

export function waLink(prefill) {
  const text = prefill ? `?text=${encodeURIComponent(prefill)}` : "";
  const number = RESTAURANT.mobile.replace(/\D/g, "");
  return `https://wa.me/${number}${text}`;
}

export function telLink(which = "mobile") {
  return `tel:${RESTAURANT[which]}`;
}

// Holiday closure announcement (auto-shows within the date range, auto-hides after).
// To disable manually before the end date, set `active: false`.
// Dates use ISO format YYYY-MM-DD (local).
export const HOLIDAY = {
  active: true,
  start: "2026-08-17",
  end: "2026-08-27", // last day of closure (inclusive)
  reopenDisplay: "28/08",
};
